import React, { useRef } from 'react';
import { connect, useSelector } from 'react-redux';

import { useDropdown } from '/hooks';

import { EstateSearchRefinementList } from "./EstateSearchRefinementList";
import {CopyService} from "../../../services";

const InternalEstateSearchFilter = props => {
    const { label, singular, plural, attribute } = props;
    const component = useRef(null);
    const { status, toggle } = useDropdown(component, 'closed');

    const filterValues = useSelector(state => state.filterValues);
    const selectedCount = (filterValues[attribute] || []).length;

    return (
        <div className={`estate-search-filter is-${status}`} ref={component}>
            <button className="estate-search-filter__trigger" onClick={toggle} >
                <React.Fragment>
                    {selectedCount === 0 && label}
                    {selectedCount === 1 && `1 ${singular} ${CopyService.get('estateSearch.selected')}`}
                    {selectedCount > 1 && `${selectedCount} ${plural} ${CopyService.get('estateSearch.selected')}`}
                </React.Fragment>
            </button>
            <svg className="estate-search-filter__icon" viewBox="0 0 24 24">
                <use xlinkHref="#icon-dropdown" />
            </svg>
            <div className="estate-search-filter__content">
                <EstateSearchRefinementList attribute={ props.attribute } clickHandler={ props.clickHandler } options={ props.categories[attribute] } />
            </div>
        </div>
    );
};

const mapStateToProps = state => {
    return {
        categories: state.categories
    }
};

const EstateSearchFilter = connect(mapStateToProps, null)(InternalEstateSearchFilter);

export { EstateSearchFilter };
